import PrimaryPagination from "./PrimaryPagination";
export default PrimaryPagination;
